import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";

import { getBlogLink } from "../helpers/getBlogLink";
import { BlogPost } from "../type";

type SideBlogItemProps = {
  blogPost: BlogPost;
};

export function SideBlogItem({ blogPost }: SideBlogItemProps) {
  const { coverImageUrl, title, description } = blogPost;
  const href = getBlogLink(blogPost);
  const { query } = useRouter();

  // exclude displaying the current blog post
  if (query.pageId === blogPost.id) {
    return null;
  }

  return (
    <div className="flex space-x-2 py-4">
      {coverImageUrl && (
        <Link href={href}>
          <div className="h-16 w-24">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              className="aspect-[3/2] h-16 w-24 object-cover"
              alt={title}
              width={300}
              height={200}
              src={coverImageUrl}
            />
          </div>
        </Link>
      )}

      <div className="max-w-[240px]">
        <Link href={href}>
          <p className="text-md truncate font-medium text-gray-900 hover:opacity-70">
            {title}
          </p>
        </Link>
        <p className="line-clamp-2 text-sm text-gray-500">{description}</p>
      </div>
    </div>
  );
}
